import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const auth = axios.create({ baseURL: API, withCredentials: true });

export async function adminLogin(email, password) {
  const { data } = await auth.post("/auth/login", { email, password });
  if (data?.token) localStorage.setItem("ehc_admin_token", data.token);
  return data;
}

export async function adminLogout() {
  try {
    await auth.post("/auth/logout");
  } catch {}
  localStorage.removeItem("ehc_admin_token");
}

export async function adminMe() {
  const token = localStorage.getItem("ehc_admin_token");
  const { data } = await auth.get("/auth/me", {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return data;
}

export function authHeaders() {
  const token = localStorage.getItem("ehc_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function adminFetch(method, path, body) {
  const { data } = await auth.request({
    method,
    url: path,
    data: body,
    headers: authHeaders(),
  });
  return data;
}
